import { createAction, props } from '@ngrx/store';
import { Position } from '../../models';

export const LoadPositions = createAction('[People] Load Positions');
export const LoadPositionsSuccess = createAction('[People] Load Positions Success', props<{ Positions: Position[] }>());
export const LoadPositionsFail = createAction('[People] Load Positions Fail', props<{ error: any }>());
